module.exports = __webpack_public_path__ + "static/media/logo-full-inverted.ea13eaed.svg";